module.exports = __webpack_public_path__ + "static/media/slide3.9ae0381e.webp";